(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('listTiles', listTiles);

    function listTiles(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: "=",
            },
            controller: listTilesCtrl,
            link: function (scope, elem, attr, ctrl) {
                scope.scopeModel = [];
                ctrl.$render = function() {
                    scope.scopeModel = ctrl.$viewValue;
                }

                scope.events = {
                    action: action
                };

                function action(event_type, dataItem) {
                    var event_prefix = lodash.get(scope.options, 'event_prefix', '');
                    if (!!event_prefix) {
                        scope.$emit(event_prefix + '.' + event_type, dataItem);
                    }
                }

            },

        };
    }

    function listTilesCtrl($scope, $element, $compile) {
        this.$onInit = function() {
            $element.html($scope.options.template);
            var cloneElement = $compile($element.contents())($scope);
        }
    }
})();